/* Mascot "Swish" v1 controller: Mascot.set(mood,target?,ms?) .pin(mood|null,target?) .mode('day'|'night') .say(text,target?,ms?) .mount(scope?) */
(() => {
  const SHOT = {hello: 1300, wake: 750, cheer: 950, celebrate: 1300};
  const doc = document, root = doc.documentElement, calm = matchMedia('(prefers-reduced-motion: reduce)');
  let mode = root.dataset.mascotMode || 'night', tapAt = 0;
  const list = t => t == null ? [...doc.querySelectorAll('.mascot')] : typeof t == 'string' ? [...doc.querySelectorAll(t)] : [t];
  const base = el => el.dataset.moodPin || (mode == 'day' && !el.classList.contains('is-night') ? 'sleep' : 'idle');
  function play(el, mood, ms) {
    clearTimeout(el._t); el.classList.remove('is-blink');
    el.dataset.mood = ''; void el.offsetWidth; el.dataset.mood = mood; // restart CSS animations
    if (ms) el._t = setTimeout(() => (el.dataset.mood = base(el)), ms);
  }
  const io = new IntersectionObserver(es => es.forEach(e => {
    const el = e.target, h = el.dataset.hello;
    el.classList.toggle('is-off', !e.isIntersecting);
    if (e.intersectionRatio < .5 || h == null || el._hi || base(el) != 'idle') return;
    el._hi = 1;
    if (h == 'session') try { if (sessionStorage.mascotHi) return; sessionStorage.mascotHi = 1 } catch (_) {}
    setTimeout(() => play(el, 'hello', SHOT.hello), 400);
  }), {threshold: [0, .5]});
  function mount(scope) {
    const tpl = doc.getElementById('mascot-tpl');
    (scope || doc).querySelectorAll('.mascot').forEach(el => {
      if (el._m) return; el._m = 1;
      if (!el.firstElementChild && tpl) el.append(tpl.content.cloneNode(true));
      el.dataset.mood = base(el);
      io.observe(el);
    });
  }
  const set = (mood, t, ms) => { mount(); list(t).forEach(el => play(el, mood, ms || SHOT[mood])) };
  const pin = (mood, t) => { mount(); list(t).forEach(el => { mood ? el.dataset.moodPin = mood : delete el.dataset.moodPin; play(el, base(el)) }) };
  function setMode(m) {
    if (!m || m == mode) return mode;
    mode = root.dataset.mascotMode = m; mount();
    list().forEach(el => el.dataset.moodPin || el.classList.contains('is-night') || el.classList.contains('is-day') ||
      play(el, m == 'day' ? 'sleep' : 'wake', m == 'night' && SHOT.wake));
    return mode;
  }
  function say(text, t, ms = 2600) {
    list(t).forEach(el => {
      const b = el.parentElement.querySelector('.mascot-say'); if (!b) return;
      clearTimeout(b._t); b.textContent = text; b.hidden = false;
      if (ms) b._t = setTimeout(() => (b.hidden = true), ms);
    });
  }
  function shut() { // one blink on every visible, open-eyed mascot
    const els = list().filter(el => !el.classList.contains('is-off') && /^(idle|sad|hello)$/.test(el.dataset.mood));
    els.forEach(el => el.classList.add('is-blink'));
    setTimeout(() => els.forEach(el => el.classList.remove('is-blink')), 130);
  }
  function blink() { // random 2.5-6 s, 20% double blink, skipped in hidden tabs and reduced motion
    if (!doc.hidden && !calm.matches) { shut(); if (Math.random() < .2) setTimeout(shut, 300) }
    setTimeout(blink, 2500 + Math.random() * 3500);
  }
  doc.addEventListener('click', e => {
    const h = e.target.closest('[data-tap]'), el = h && (h.matches('.mascot') ? h : h.querySelector('.mascot'));
    if (!el || Date.now() - tapAt < 700) return; tapAt = Date.now();
    const mood = base(el) == 'sleep' ? 'wake' : 'cheer'; play(el, mood, SHOT[mood]);
  });
  const init = () => { mount(); setTimeout(blink, 3000) };
  doc.readyState == 'loading' ? doc.addEventListener('DOMContentLoaded', init) : init();
  window.Mascot = window.Swish = {set, pin, mode: setMode, say, mount};
})();

/* theiro event wiring for Swish (adapted from plan/mascot-demo.html hooks). */
(() => {
  const M = window.Mascot;
  if (!M) return;
  const doc = document;
  const on = (name, fn) => doc.addEventListener(name, (e) => fn(e.detail || {}));
  const HERO = '[data-mascot-role=hero]';
  const GAME = '[data-mascot-role=game]';
  const SEEN = '.mascot:not(.is-off)';
  let cheerAt = 0;
  const cheer = () => {
    if (Date.now() - cheerAt < 800) return;
    cheerAt = Date.now();
    setTimeout(() => { M.mount(); M.set('cheer', SEEN); }, 350);
  };
  on('glow:atc-success', cheer);
  on('glow:atc-error', () => M.set('sad', SEEN, 900));
  on('glow:daynight', (d) => M.say(d.mode === 'day' ? 'Charging. Zzz.' : 'Lights off.', HERO, 2000));
  const GAME_MOOD = {
    start: ['idle', 'Swipe up.'], score: ['cheer', 'Bucket.'], swish: ['celebrate', 'Swish.'],
    streak: ['celebrate', 'You’re glowing.'], miss: ['sad', 'Rim. Again.'], over: ['celebrate', 'Code unlocked.'],
  };
  on('glow:game', (d) => {
    const g = GAME_MOOD[d.type];
    if (!g) return;
    M.set(g[0], GAME, d.type === 'miss' ? 800 : 0);
    M.say(g[1], GAME, 1600);
  });
  ['pointerover', 'focusin'].forEach((type) => doc.addEventListener(type, (e) => {
    const trigger = e.target.closest && e.target.closest('[data-mascot-light]');
    if (!trigger) return;
    const el = doc.querySelector(trigger.dataset.mascotLight);
    if (!el || !el.classList.contains('is-day')) return;
    el.classList.replace('is-day', 'is-night');
    M.pin(null, el);
    M.set('hello', el);
  }));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(M.mount, 80));
  }
  const observer = new MutationObserver(() => M.mount());
  const watch = () => { const d = doc.getElementById('CartDrawer'); if (d) observer.observe(d, { childList: true, subtree: true }); };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch); else watch();
  doc.addEventListener('shopify:section:load', (e) => M.mount(e.target));
  setTimeout(() => M.say(M.mode() === 'day' ? 'Charge me up.' : 'Charged. Let’s play.', HERO), 4000);
})();
